import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {EntityDataBasic} from '../../../shared/types/nso-data-portal/entity-data';
import {FileUtilsService} from '../../../shared/services/common/file/file-utils.service';

@Component({
  selector: 'wsd-federations',
  templateUrl: './federations.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./federations.component.css']
})
export class FederationsComponent {

  @Input()
  federations: EntityDataBasic[];

  constructor(private fileUtilsService: FileUtilsService) { }

  getImage(content) {
    if (content) {
      return this.fileUtilsService.getImage(content);
    } else {
      return 'assets/images/organization.png';
    }
  }

}
